import React,{useState} from "react";
import { Grid, GridList, GridListTile, Hidden, Tab,Tabs,makeStyles } from "@material-ui/core";
import moment from "moment";
import { Typography } from "@packages/ui";

const validGPS = (coordinate) => coordinate && coordinate !== -1;

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',

  },
  tabs: {
    borderRight: `0px solid ${theme.palette.divider}`,
    width: '70vw'
  },
  
}));


const PreviousPhotoBatch = ({
  batch_type,
  comments,
  batch_date: timestamp,
  coordinates,
  photo_urls: photoUrls,
  handleOpenLightbox,
}) => {
  const timestampSeconds = timestamp / 1000;
  const dateTime = moment.unix(timestampSeconds).format("DD/MM/YYYY HH:mm");
  const isStaffUpload = batch_type === "STAFF";
  const { longitude, latitude } = coordinates;
  const [value, setValue] = useState(0);

  const showCoordinates = !isStaffUpload && validGPS(latitude) && validGPS(longitude);
  const handleChange = (event, newValue) =>{
    setValue(newValue)
  }
  const classes = useStyles();

  return (
    <Grid container spacing={2} style={{ marginTop: 30 }}>
      <Grid item md={12}>
        {isStaffUpload && (
          <>
            <Typography paragraph>
              This photo batch was uploaded by a staff on <strong>{dateTime}</strong>.
            </Typography>
            {comments && <Typography paragraph>Comments: {comments}</Typography>}
          </>
        )}
        {!isStaffUpload && (
          <>
            <Typography paragraph>
              This photo batch was uploaded by you on <strong>{dateTime}</strong>.
            </Typography>
            {showCoordinates && (
              <Typography paragraph>
                <strong>GPS Coordinates:</strong> &#123; {latitude}, {longitude} &#125;
              </Typography>
            )}
            {comments && (
              <Typography paragraph>
                <strong>Comments</strong> {comments}
              </Typography>
            )}
          </>
        )}

      </Grid>

      <Hidden mdDown>
        <div className={classes.root}>
          <Tabs md={12}
            orientation="horizantal"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Rental Photos"
            className={classes.tabs}
          >
            {photoUrls.map((photoUrl, index) => {
              const onClick = () => handleOpenLightbox(photoUrl);
              return (
                <Tab key={index} lg={3} sm={6} xl={3} xs={12}
                  label={
                    <a
                      onClick={onClick}
                      style={{ display: "inline", cursor: "pointer" }}
                      value={index}
                    >
                      <img key={index} name={index} src={photoUrl} height="70%" width="70%" style={{ display: 'block' }} />
                    </a>}>
                </Tab>
              );
            })}

          </Tabs>
        </div>
      </Hidden>
      <Hidden lgUp>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around' }}>
          <GridList style={{ flexWrap: 'nowrap', transform: 'translateZ(0)' }} md={12} spacing={2} cols={3.5} cellHeight={100}>
            {photoUrls.map((photoUrl, index) => {
              const onClick = () => handleOpenLightbox(photoUrl);
              return (
                <GridListTile key={index} lg={10} sm={6} xl={3} xs={12}>
                  <a onClick={onClick} style={{ display: "inline", cursor: "pointer" }} value={index}>
                    <img name={index} src={photoUrl} width="80%" height="120%" style={{ display: 'block' }} />
                  </a>

                </GridListTile>
              );
            })}
          </GridList>
        </div>
      </Hidden>
      {/* <Grid item container md={12} spacing={2}>
        {photoUrls.map((photoUrl, index) => {
          const onClick = () => handleOpenLightbox(photoUrl);
          return (
            <Grid key={index} item lg={3} sm={6} xl={3} xs={12}>
              <a onClick={onClick} style={{ display: "inline", cursor: "pointer" }} value={index}>
                <img name={index} src={photoUrl} width="100%" />
              </a>
            </Grid>
          );
        })}
      </Grid> */}
    </Grid>
  );
};

export default PreviousPhotoBatch;
